._StackedRadioGroup_12rpd_1 {
  justify-content: space-between;
}

._RelatedFieldset_12rpd_5 {
  flex: 1;
}
